import api, { checkTokenErrorResponse } from '.';

import academyServices from './academy/academyServices';
import coachServices from './academy/coachServices';
import studentsServices from './academy/studentsServices';

import accessServices from './accessServices';

export async function login(email, password) {
    return api.post("login/", {
            email,
            password,
        })
        .then(async function (response) {
            // handle success
            const { token, userID, id, tipo, timezone } = response.data;
            api.defaults.headers.common['Authorization'] = `Token ${token}`;
            api.defaults.headers.common['TIMEZONE'] = timezone;
            api.defaults.headers.common['USERTYPE'] = tipo;
            localStorage.setItem("_token", token);
            localStorage.setItem("_userType", tipo);
            localStorage.setItem("_userID", userID);
            localStorage.setItem("_id", id);
            localStorage.setItem('_timezone', timezone);
            if (tipo === "academia") {
                console.log("Login de academia!");
                let response = await academyServices.getAcademyInfos();
                localStorage.setItem("_academyInfos", JSON.stringify(response.data));
            } else if (tipo === "professor") {
                console.log("Login de professor!");
                let response = await coachServices.getCoachInfos(id);
                localStorage.setItem("_coachInfos", JSON.stringify(response.data));
                response = await academyServices.getAcademyInfos();
                localStorage.setItem("_academyInfos", JSON.stringify(response.data));
            } else if (tipo === "aluno") {
                console.log("Login de aluno!");
                let response = await studentsServices.getStudentInfos(id);
                localStorage.setItem("_studentInfos", JSON.stringify(response.data));
                // response = await academyServices.getAcademyInfos(id);
                // localStorage.setItem("_academyInfos", JSON.stringify(response.data));
            }
            else if (tipo === "acesso") {
                console.log("Login de acesso!");
                let response = await accessServices.getAccessInfos(id);
                localStorage.setItem("_accessInfos", JSON.stringify(response.data));
            }
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

export async function checkToken() {
    return api.get("check_token/")
        .then(function (response) {
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

export async function logout() {
    localStorage.clear();
    return api.post("logout/")
        .then(function (response) {
            delete api.defaults.headers.common['Authorization'];
            delete api.defaults.headers.common['TIMEZONE'];
            delete api.defaults.headers.common['USERTYPE'];
            // handle success
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

export async function forgotPassword(email) {
    return api.post("forgot_password/", {
            email,
        })
        .then(function (response) {
            // handle success
            console.log("Link de recuperação de senha enviado, confira seu email!");
            alert("Link de recuperação de senha enviado, confira seu email!");
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

export async function changePassword(password, token) {
    return api.post("change_password/", { password }, {
        headers: {
            Authorization: "Token " + token
        }
    })
        .then(function (response) {
            // handle success
            console.log("Senha trocada com sucesso!!");
            return response;
        })
        .catch(function (error) {
            // handle error
            console.log(error);
            if (error.response) {
                console.log(error.response.data);
                checkTokenErrorResponse(error.response);
            }
            return error;
        });
}

const userServices = {
    login,
    checkToken,
    logout,
    forgotPassword,
    changePassword,
}
export default userServices;